/**
 * État IA de démonstration, local et sans fournisseur. Les galeries restent
 * isolées par identifiant, les montants en cents et les coupures historisées.
 * Les motifs sont des chaînes rendues comme du texte par les écrans.
 */
import { demoApi } from './demoData.js';
import type { ConsoleIa, GalerieIa, CoupureIa, ReglagesIa } from './ia.js';

const mois = () =>
  new Intl.DateTimeFormat('fr-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit' })
    .format(new Date())
    .slice(0, 7);

let globale: ConsoleIa | undefined;

const galeries = new Map<string, GalerieIa>();

export function demoIa(): ConsoleIa {
  const galerieId = demoApi.listerGaleries()[0]?.id ?? 'demo';
  globale ??= {
    lisibles: true,
    coupee: false,
    secours: false,
    usagesCoupes: [],
    historique: [],
    mois: mois(),
    depenseMicro: 16400000,
    depenseCents: 1640,
    premieresGaleries: [{ galleryId: galerieId, depenseMicro: 16400000, depenseCents: 1640 }],
    galeriesSeuil80: [galerieId],
  };
  return structuredClone(globale);
}

export function ecrireDemoIa(corps: CoupureIa): ConsoleIa {
  globale = {
    ...demoIa(),
    coupee: corps.coupee,
    usagesCoupes: corps.usagesCoupes,
    historique: [
      { ...corps, auteur: 'Direction (démo)', modifieLe: new Date().toISOString() },
      ...demoIa().historique,
    ],
  };
  return demoIa();
}

export function demoIaGalerie(id: string): GalerieIa {
  if (!galeries.has(id))
    galeries.set(id, {
      plafondMensuelCents: null,
      plafondEffectifCents: 2000,
      suspendue: false,
      motif: '',
      consommations: [
        {
          mois: mois(),
          depenseMicro: 16400000,
          depenseCents: 1640,
          reserveMicro: 0,
          appels: 32,
          refus: 1,
          jetonsEntree: 8000,
          jetonsSortie: 1600,
          parUsage: { 'voix:apercu': { appels: 32, depenseMicro: 16400000, depenseCents: 1640 } },
        },
      ],
    });
  return structuredClone(galeries.get(id)!);
}

export function ecrireDemoIaGalerie(id: string, corps: ReglagesIa): GalerieIa {
  galeries.set(id, {
    ...demoIaGalerie(id),
    ...corps,
    plafondEffectifCents: corps.plafondMensuelCents ?? 2000,
  });
  return demoIaGalerie(id);
}
